import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { Button, ModalFooter, Anchor } from '@any-ui-react/core';

import { CrmRoutePaths } from '@anyx/common-routing';

import { useGetRichMenus } from '../hooks';
import { RichMenuSelectorList } from '../rich-menu-selector-list';
import { RichMenuItem } from '../types';

interface RichMenuSelectorContentProps {
  onClose: () => void;
  onConfirm: (richMenu: RichMenuItem) => void;
  storeId: string;
  richMenuId?: string;
}

export const RichMenuSelectorContent = ({
  onClose,
  onConfirm,
  storeId,
  richMenuId,
}: RichMenuSelectorContentProps) => {
  const { richMenuList, isLoadingMore, fetchMoreRichMenus, loading } = useGetRichMenus(storeId);

  const initialRichMenu = richMenuList.filter((rm) => rm.id === richMenuId)[0];

  const [selectedRichMenu, setSelectedRichMenu] = useState<RichMenuItem | undefined>(
    initialRichMenu
  );
  const { t } = useTranslation(['shared']);

  const richMenuListPath = CrmRoutePaths(storeId).line().richMenu().path;

  return (
    <div>
      <Trans
        i18nKey="crm.richMenuSelector.dialog.selectRichMenu.desc"
        ns="crm"
        className="mb-4"
        components={[<Anchor component={Link} to={richMenuListPath} target="_blank" />]}
        parent="p"
      />
      <RichMenuSelectorList
        onClose={onClose}
        loading={loading}
        fetchMoreRichMenus={fetchMoreRichMenus}
        isLoadingMore={isLoadingMore}
        richMenuList={richMenuList}
        to={richMenuListPath}
        onSelect={(richMenu) => setSelectedRichMenu(richMenu)}
        selectedRichMenuId={selectedRichMenu?.id}
      />

      <ModalFooter>
        <Button variant="default" onClick={onClose}>
          {t('shared.button.cancel', { ns: 'shared' })}
        </Button>
        {richMenuList.length > 0 && (
          <Button
            disabled={!selectedRichMenu}
            color="blue"
            onClick={() => {
              if (selectedRichMenu) {
                onConfirm(selectedRichMenu);
                onClose();
              }
            }}
          >
            {t('shared.button.save', { ns: 'shared' })}
          </Button>
        )}
      </ModalFooter>
    </div>
  );
};
